// Version : 0.0.1
// Author : AGALYA
// LastEdit : SHIYAM
// Last ADD : imported types path properly
// MODFIED DATE : 04-08-2025

import PurposeOfLoanActionTypes from './purpose-of-loan.types';

/** ***************** ADD PURPOSE OF LOAN DETAILS START *********************** */
export const addPurposeOfLoanDetailsStart = (addData: any) => ({
	type: PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_START,
	payload: addData,
});

export const addPurposeOfLoanDetailsSuccess = (successData: any) => ({
	type: PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const addPurposeOfLoanDetailsFailure = (failureData: any) => ({
	type: PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const addPurposeOfLoanDetailsResponseResetStart = () => ({
	type: PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
});

export const addPurposeOfLoanDetailsResponseChanged = () => ({
	type: PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** UPDATE PURPOSE OF LOAN DETAILS START *********************** */
export const updatePurposeOfLoanDetailsStart = (updateData: any) => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_START,
	payload: updateData,
});

export const updatePurposeOfLoanDetailsSuccess = (successData: any) => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const updatePurposeOfLoanDetailsFailure = (failureData: any) => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const updatePurposeOfLoanDetailsResponseResetStart = () => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
});

export const updatePurposeOfLoanDetailsResponseChanged = () => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** GET PURPOSE OF LOAN LIST START *********************** */
export const getPurposeOfLoanListStart = (getData: any) => ({
	type: PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_START,
	payload: getData,
});

export const getPurposeOfLoanListSuccess = (successData: any) => ({
	type: PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const getPurposeOfLoanListFailure = (failureData: any) => ({
	type: PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const getPurposeOfLoanListResponseResetStart = () => ({
	type: PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_RESPONSE_RESET,
});

export const getPurposeOfLoanListResponseChanged = () => ({
	type: PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_RESPONSE_CHANGED,
});

/** ***************** GET PURPOSE OF LOAN LIST END *********************** */

/** ***************** FETCH PURPOSE OF LOAN DETAILS START *********************** */
export const fetchPurposeOfLoanDetailsStart = (fetchData: any) => ({
	type: PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_START,
	payload: fetchData,
});

export const fetchPurposeOfLoanDetailsSuccess = (successData: any) => ({
	type: PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchPurposeOfLoanDetailsFailure = (failureData: any) => ({
	type: PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchPurposeOfLoanDetailsResponseResetStart = () => ({
	type: PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
});

export const fetchPurposeOfLoanDetailsResponseChanged = () => ({
	type: PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** DELETE PURPOSE OF LOAN DETAILS START *********************** */
export const deletePurposeOfLoanDetailsStart = (deleteData: any) => ({
	type: PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_START,
	payload: deleteData,
});

export const deletePurposeOfLoanDetailsSuccess = (successData: any) => ({
	type: PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const deletePurposeOfLoanDetailsFailure = (failureData: any) => ({
	type: PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const deletePurposeOfLoanDetailsResponseResetStart = () => ({
	type: PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
});

export const deletePurposeOfLoanDetailsResponseChanged = () => ({
	type: PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS START *********************** */
export const updatePurposeOfLoanPublishStatusStart = (updateData: any) => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_START,
	payload: updateData,
});

export const updatePurposeOfLoanPublishStatusSuccess = (successData: any) => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_SUCCESS,
	payload: successData,
});

export const updatePurposeOfLoanPublishStatusFailure = (failureData: any) => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_FAILURE,
	payload: failureData,
});

export const updatePurposeOfLoanPublishStatusResponseResetStart = () => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_RESET,
});

export const updatePurposeOfLoanPublishStatusResponseChanged = () => ({
	type: PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_CHANGED,
});
/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS END *********************** */
